/* eslint-disable no-unused-vars */
import Swiper from 'swiper/js/swiper';
import '~/sass/pages/tech-safety.scss';
import '~/js/libs/youtube/lite-yt-embed.css';
import '@/libs/youtube/lite-yt-embed';

const { $ } = window;

let swiperAdvantage = null;
let swiperMeasure = null;
let swiperExtremelyPassive = null;
let swiperExtremelyActive = null;


function initAdvantageSwipers() {
  swiperAdvantage = new Swiper('#safety-info .swiper-info .swiper-container', {
    slidesPerView: 1,
    centeredSlides: true,
    spaceBetween: 0,
    observer: true,
    observeParents: true,
    centerInsufficientSlides: true,
    navigation: {
      nextEl: '#safety-info .swiper-info .swiper-button-next',
      prevEl: '#safety-info .swiper-info .swiper-button-prev',
    },
    breakpoints: {
      768: {
        slidesPerView: 3,
        centeredSlides: false,
      },
      1140: {
        slidesPerView: 4,
        centeredSlides: false,
      },
    },
  });
}

function initMeasureSwipers() {
  swiperMeasure = new Swiper('#measure .swiper-container', {
    slidesPerView: 1,
    centeredSlides: true,
    observer: true,
    observeParents: true,
    autoHeight: true,
    navigation: {
      nextEl: '#measure .swiper-button-next',
      prevEl: '#measure .swiper-button-prev',
    },
    on: {
      transitionEnd() {
        const active = swiperMeasure.activeIndex;
        console.log(active);
        console.log($(`[data-nav="measure"].nav-link[data-index=${active}]`));
        if ($(`[data-nav="measure"].nav-link[data-index=${active}]`).length === 1) {
          $(`[data-nav="measure"].nav-link[data-index=${active}]`).trigger('click');
        }
      },
    },
  });
  $('#measure .scroll-menu-list.fancyboxSlide .nav-link').on('click', function popIndex() {
    const thisIndex = $(this).attr('data-index');
    $(this).closest('.scroll-menu-list').find('.nav-link').removeClass('active');
    $(this).addClass('active');
    console.log(thisIndex);
    swiperMeasure.slideTo(thisIndex, 500, false);
  });
}

function initSwiperExtremelyActive() {
  if ($('#extremely-active .swiper-wrapper').length > 0) {
    // const tag = document.createElement('script');
    // tag.src = 'https://www.youtube.com/iframe_api';
    // const firstScriptTag = document.getElementsByTagName('script')[0];
    // firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    // 3. This function creates an <iframe> (and YouTube player)

    const initPlayer = function init(element) {
      // const player = element.querySelector('.video-iframe');
      // const button = element.querySelector('.video-play');
      // eslint-disable-next-line no-undef
      // const ytplayer = new YT.Player(player, {
      //   playerVars: {
      //     autoplay: 0,
      //     modestbranding: 1,
      //     controls: 0,
      //     rel: 0,
      //   },
      //   videoId: element.dataset.id,
      // });

      // button.addEventListener('click', () => {
      //   console.log(ytplayer);
      //   console.log(ytplayer.getPlayerState());
      //   ytplayer.playVideo();
      //   switch (ytplayer.getPlayerState()) {
      //     case 1:
      //       ytplayer.stopVideo();
      //       $(button).removeClass('playing');
      //       break;
      //     default:
      //       ytplayer.playVideo();
      //       $(button).addClass('playing');
      //       break;
      //   }
      // });
    };

    swiperExtremelyActive = new Swiper('#extremely-active .swiper-container', {
      slidesPerView: 1.25,
      centeredSlides: true,
      navigation: {
        nextEl: '#extremely-active .swiper-button-next',
        prevEl: '#extremely-active .swiper-button-prev',
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
          centeredSlides: false,
        },
        1024: {
          slidesPerView: 3,
          centeredSlides: false,
        },
      },
    }).on('slideChange', () => {
      const isVideo = swiperExtremelyActive.slides[swiperExtremelyActive.previousIndex].querySelector('.video');
      const active = swiperExtremelyActive.activeIndex;
      const activeSlide = swiperExtremelyActive.slides[active];
      const nowActiveNav = $('[data-nav="extremely-active"].nav-link.active').attr('data-index');

      if (isVideo) {
        const videoId = isVideo.dataset.id;
        const iframe = $(`#extremely-active lite-youtube[videoid=${videoId}] iframe`).get(0);
        if (!iframe) {
          return;
        }
        iframe.contentWindow.postMessage(JSON.stringify({
          event: 'command',
          func: 'stopVideo',
        }), '*');
      }

      if (active < nowActiveNav) {
        $('[data-nav="extremely-active"].nav-link').removeClass('active');
        $(`[data-nav="extremely-active"].nav-link[data-index=${nowActiveNav}]`).parent().prev().find('.nav-link')
          .addClass('active');

        const $scrollNav = $(`[data-nav="extremely-active"].nav-link[data-index=${nowActiveNav}]`).parent().prev().find('.nav-link')
          .parent();
        let pos = $scrollNav.position().left;
        const posWidth = $scrollNav.width();
        const currentscroll = $scrollNav.parent().scrollLeft();
        const divwidth = $scrollNav.parent().width();
        pos = (pos + currentscroll) - (divwidth / 2) + (posWidth / 2) + 10;

        $scrollNav.parent().animate({
          scrollLeft: pos,
        });

        const nowActiveNavID = $(`[data-nav="extremely-active"].nav-link[data-index=${nowActiveNav}]`).parent().prev().find('.nav-link')
          .attr('id');
        // console.log(nowActiveNavID);
        $('#extremely-active [data-text]').hide();
        switch (nowActiveNavID) {
          case 'extremely-active-2':
            $('#extremely-active [data-text="2"]').show();
            break;
          case 'extremely-active-3':
            $('#extremely-active [data-text="3"]').show();
            break;
          case 'extremely-active-4':
            $('#extremely-active [data-text="4"]').show();
            break;
          default:
            $('#extremely-active [data-text="1"]').show();
        }
      } else {
        $(`[data-nav="extremely-active"].nav-link[data-index=${active}]`).trigger('click');
        $(activeSlide).find('.icon-list li:eq(0)').trigger('click');
      }
    });

    // window.onYouTubePlayerAPIReady = function ready() {
    //   const container = document.querySelectorAll('.video');
    //   for (let i = 0; i < container.length; i += 1) {
    //     initPlayer(container[i]);
    //   }
    // };
  }

  $('#extremely-active .scroll-menu-list.fancyboxSlide .nav-link').on('click', function popIndex() {
    const thisIndex = $(this).attr('data-index');
    $(this).closest('.scroll-menu-list').find('.nav-link').removeClass('active');
    $(this).addClass('active');
    console.log(thisIndex);
    swiperExtremelyActive.slideTo(thisIndex, 500, false);
    const navID = $(this).attr('id');
    $('#extremely-active [data-text]').hide();
    switch (navID) {
      case 'extremely-active-2':
        $('#extremely-active [data-text="2"]').show();
        break;
      case 'extremely-active-3':
        $('#extremely-active [data-text="3"]').show();
        break;
      case 'extremely-active-4':
        $('#extremely-active [data-text="4"]').show();
        break;
      default:
        $('#extremely-active [data-text="1"]').show();
    }
  });
}

function initSwiperExtremelyPassive() {
  swiperExtremelyPassive = new Swiper('#extremely-passive .swiper-container', {
    slidesPerView: 1,
    centeredSlides: true,
    observer: true,
    observeParents: true,
    navigation: {
      nextEl: '#extremely-passive .swiper-button-next',
      prevEl: '#extremely-passive .swiper-button-prev',
    },
    on: {
      transitionEnd() {
        const active = swiperExtremelyPassive.activeIndex;
        console.log(active);
        console.log($(`[data-nav="extremely-passive"].nav-link[data-index=${active}]`));
        if ($(`[data-nav="extremely-passive"].nav-link[data-index=${active}]`).length === 1) {
          $(`[data-nav="extremely-passive"].nav-link[data-index=${active}]`).trigger('click');
        }
      },
    },
  });
  $('#extremely-passive .scroll-menu-list.fancyboxSlide .nav-link').on('click', function popIndex() {
    const thisIndex = $(this).attr('data-index');
    $(this).closest('.scroll-menu-list').find('.nav-link').removeClass('active');
    $(this).addClass('active');
    console.log(thisIndex);
    swiperExtremelyPassive.slideTo(thisIndex, 500, false);
  });
}

function scrollToextremelyActive() {
  const initWindowWidth = $(window).outerWidth();
  $('#extremely-safe a[href*="#"]').on('click', () => {
    if (initWindowWidth >= 1024) {
      $('html, body').stop().animate({
        scrollTop: $('#extremely-active').offset().top - 72,
      }, 500);
    } else {
      $('html, body').stop().animate({
        scrollTop: $('#extremely-active').offset().top - 56,
      }, 500);
    }
  });
}

$(document).ready(() => {
  initAdvantageSwipers();
  initMeasureSwipers();
  initSwiperExtremelyActive();
  initSwiperExtremelyPassive();
  scrollToextremelyActive();

  $(window).on('resize', () => {
    scrollToextremelyActive();
  });
});
